var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.808 0C2.59 0 0 2.526 0 5.663v19.686c0 3.137 2.59 5.663 5.808 5.663h10.944V18.888h-3.289v-4.365h3.289v-3.729c0-2.93 1.942-5.62 6.418-5.62 1.812 0 3.151.17 3.151.17l-.105 4.076s-1.366-.013-2.858-.013c-1.613 0-1.872.725-1.872 1.929v3.187h4.858l-.211 4.365h-4.647v12.124h4.513c3.218 0 5.808-2.526 5.808-5.663V5.663C31.807 2.526 29.217 0 26 0H5.808z",
    fill: "#009645"
  })));
}
export default SvgFacebook;